import type { TokenManager } from './tokenManager';

export interface SessionPrewarmConfig {
  tokenManager: TokenManager;
  /** True when this tab probably holds a session the refresh cookie can restore. */
  hasSession: () => boolean;
}

/**
 * Starts the silent session refresh as soon as the page's script runs, rather
 * than when React mounts the auth provider — which only happens once the
 * runtime config and the translation files are in. The provider then collects
 * the same in-flight request with `take()`, so the refresh still fires exactly
 * once and a failed one is not repeated.
 */
export function createSessionPrewarm({
  tokenManager,
  hasSession,
}: SessionPrewarmConfig) {
  let pending: Promise<string | null> | null = null;

  return {
    start(): void {
      if (pending || !hasSession()) return;
      pending = tokenManager.getValidToken();
    },

    /** Hands over the refresh `start` began, once. `null` when none is waiting. */
    take(): Promise<string | null> | null {
      const taken = pending;
      pending = null;
      return taken;
    },
  };
}
